import PropTypes from "prop-types";

const _AllPosts = PropTypes.shape({
  acf_fc_layout: PropTypes.string,
  posts_per_page: PropTypes.string,
  posts_type: PropTypes.string,
});

export const AllPostsPropTypes = {
  data: PropTypes.oneOfType([_AllPosts, PropTypes.any]),
};

export const _AllPostsPagination = {
  changePage: PropTypes.func,
  page: PropTypes.number,
  pages: PropTypes.number,
};

export const AllPostsPaginationPropTypes = _AllPostsPagination;
